import { createSelector } from 'reselect';

import { ILoanTypesState, IRootState } from '../../models';

export const selectLoanTypesState = (rootState: IRootState): ILoanTypesState => rootState.loanTypesState;

export const selectLoanTypes = createSelector([selectLoanTypesState], (loanTypesState) => loanTypesState.loanTypes);
